// 빈 제목6과 이미지 전용 제목6을 실제 텍스트 버튼과 구분한다.
export function normalizeHeadingButtons(root) {
  root.querySelectorAll("h6").forEach(heading => {
    const text = heading.textContent.replace(/[\s\u00a0\u200b]/g, "");
    const media = heading.querySelector("img,video,iframe,svg");
    const kind = text ? "text" : media ? "media" : "empty";
    if (heading.dataset.headingButton !== kind) heading.dataset.headingButton = kind;
  });
}
